import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import CryptoJS from 'crypto-js'
import VueCryptojs from 'vue-cryptojs'
import './index.css'


Vue.config.productionTip = false


new Vue({
  router,
  store,
  CryptoJS,
  VueCryptojs,
  render: h => h(App),
}).$mount('#app')
